/*
 * @Description: 
 * @Author: shenkaiyao
 * @Date: 2020-09-27 09:25:21
 * @LastEditors: 
 * @LastEditTime: 2020-09-27 09:27:40
 */
import FormTabs from './formTabs'

export default FormTabs